const baseURL = '/api'
const timeout = 60000
const config = { baseURL, timeout }
export default config
